import {
  PROFILE_FETCH_REQUEST,
  PROFILE_FETCH_SUCCESS,
  PROFILE_FETCH_FAILURE,
  PROFILE_CLEAR,
} from '../actions/actionTypes';
import { ProfileAction } from '../actions/profileActions';

export interface ProfileState {
  profileId: string | null;
  data: any | null;
  loading: boolean;
  error: string | null;
  /** The environment `data` was read from. */
  environment: string | null;
}

const initialState: ProfileState = {
  profileId: null,
  data: null,
  loading: false,
  error: null,
  environment: null,
};

export default function profileReducer(
  state: ProfileState = initialState,
  action: ProfileAction,
): ProfileState {
  switch (action.type) {
    case PROFILE_FETCH_REQUEST: {
      // Re-reading the profile already on screen (after an edit, or the page's refresh on
      // mount) keeps it showing until the new copy lands, instead of blanking the page
      // (2026-10-14). Another profile, or the other environment, starts empty.
      const same = state.profileId === action.payload && state.environment === action.environment;
      return {
        ...state,
        loading: true,
        error: null,
        data: same ? state.data : null,
        profileId: action.payload,
        environment: action.environment,
      };
    }
    case PROFILE_FETCH_SUCCESS:
      return { ...state, loading: false, profileId: action.payload.id, data: action.payload.data };
    case PROFILE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case PROFILE_CLEAR:
      return initialState;
    default:
      return state;
  }
}
